export default __webpack_public_path__ + "static/media/pokiPort@3x.469dde6e.png";